<section>
  <div class="container upper">
    <div class="row flex-row chat ">
      <div class="col-lg-12 px-0">
        <div class="card">
          <div id="chat-header" class="card-header d-inline-block">

            <h3 class="mb-0">Chat Channel</h3>
          </div>


          <div id="chat-message-body" class="card-body">
            <div style="display: flex;justify-content: flex-end">
              <button (click)="fetchMessage()" *ngIf="this.moreLoad" class="btn btn-primary btn-sm btn-load-more">Load
                earlier messages
              </button>
            </div>

            <div #scrollContainer class="chat-container">
              <!-- Render existing messages -->
              <div *ngFor="let message of messages">
                <div
                  [ngClass]="{'justify-content-end text-right': message.sender === 'You',
                  'justify-content-start': message.sender !== 'You'}"
                  class="row"
                >
                  <div class="col-auto">
                    <div
                      [ngClass]="{'bg-gradient-primary text-white': message.sender === 'You'}"
                      class="card"
                    >

                      <div class="card-body p-2">
                        <ng-container *ngIf="message.sender !== 'You'">
                          <small><i>{{ message.sender }}</i></small>
                        </ng-container>

                        <p [class.mt-1]="message.sender !== 'You'" class="mb-1">{{ message.text }}</p>
                        <div class="d-flex justify-content-between align-items-center">
                          <small class="opacity-60">
                            <i class="far fa-clock"></i> {{ convertToLocalDateTime(message.time) }}
                          </small>
                          <button *ngIf="message.sender === 'You'"
                                  class="btn btn-sm btn-link text-white p-0 ml-2"
                                  (click)="openDeleteConfirmation(message.id)"
                                  [disabled]="isDeleting">
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div id="chat-send-footer" class="card-footer d-block">
            <div class="form-group">
              <div class="input-group mb-0">
                <input
                  (blur)="focus = false"
                  (focus)="focus = true"
                  (keydown.enter)="sendMessage()"
                  [(ngModel)]="newMessage"
                  class="form-control"
                  placeholder="Your message"
                  type="text"
                />
                <div class="input-group-append">
<span
  (click)="sendMessage()"
  [ngClass]="{ 'bg-gradient-primary': focus }"
  class="input-group-text"
>
<i class="ni ni-send"></i>
</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
